// extracted by mini-css-extract-plugin
module.exports = {"block":"Footer-Block-module--block--2hUox","desktopOnly":"Footer-Block-module--desktopOnly--2uWu5"};